import { useTranslation } from 'react-i18next';
import { useIsMobile } from '../../hooks/useIsMobile';
import { landingMedia } from './media';

interface LandingHeaderProps {
  onStart: () => void;
}

export default function LandingHeader({ onStart }: LandingHeaderProps) {
  const { t } = useTranslation(['landing', 'common']);
  const isNarrow = useIsMobile(720);

  const links: Array<[string, string]> = [
    ['#create', t('landing:nav.create', 'Create')],
    ['#platform', t('landing:nav.platform', 'Platform')],
    ['#games', t('landing:nav.games', 'Games')],
    ['#community', t('landing:nav.community', 'Community')],
  ];

  return (
    <header className="site-header">
      <a href="/" className="wordmark">
        <img src={landingMedia.logo} alt="" />
        {t('common:app.name', 'Entire')}
      </a>
      {!isNarrow && (
        <nav className="site-nav">
          {links.map(([href, label]) => (
            <a key={href} href={href} className="nav-link">
              {label}
            </a>
          ))}
        </nav>
      )}
      <button type="button" className="btn primary sm" onClick={onStart}>
        {t('landing:cta.startFree', 'Start Free')}
      </button>
    </header>
  );
}
